module.exports = __webpack_public_path__ + "img/situation_banner.82d5ba81.png";